import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import {first, tap} from 'rxjs/operators';
import { PaymentsApiService } from "@app/core/api/services/payments-api.service";
import {EnvironmentService} from "@environments/environment.service";



@Injectable({
  providedIn: 'root'
})
export class PaypalService {
  private clientID = "";
  
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PaymentsApiService) private paymentService: PaymentsApiService,
    private envService: EnvironmentService,
  ) {

    this.envService.environment
        .pipe(tap((env) => (this.clientID = env.paypalClientId)))
        .subscribe();
  }

  userToken!: string;

  async getToken() {
    let token = await this.paymentService.GetUserIdToken({}).toPromise();
    // @ts-ignore
    this.userToken = !!token ? token.id_token : undefined;
  }

  public addScript(): Observable<void> {
    // @ts-ignore
    // let token = await this.paymentService.GetUserIdToken({}).toPromise().id_token;
    this.getToken();

    const paypalScriptElement: HTMLScriptElement = this.document.createElement('script');
    paypalScriptElement.src = `https://www.paypal.com/sdk/js?client-id=${this.clientID}`;
    paypalScriptElement.src += '&vault=true&disable-funding=venmo,paylater,card,credit';
    paypalScriptElement.setAttribute('data-user-id-token', this.userToken);
    paypalScriptElement.id = 'paypal-script';
    this.document.head.appendChild(paypalScriptElement);

    return fromEvent<void>(paypalScriptElement, 'load').pipe(first());
  }

  public removeScript() {
    const paypalScriptElement = this.document.getElementById('paypal-script');
    if (paypalScriptElement) this.document.head.removeChild(paypalScriptElement);
  }
}
